<template>
  <div>
    <!-- 客户属性 -->
    <el-dialog :title="$t('message.customerProperty')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="488px" center>
      <div class="content">
        <div class="key">
          <!--潜力客户  -->

          <el-radio v-model="detail.is_vip" :label="1">{{ $t('message.potentialCustomer') }}</el-radio>
        </div>
        <div class="key">
          <!--普通客户  -->
          <el-radio v-model="detail.is_vip" :label="0">{{ $t('message.ordinaryCustomer') }}</el-radio>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="dialogVisible = false">{{
          $t("message.cancel")
        }}</el-button>
        <!-- 保存 -->
        <el-button type="primary" @click="save">{{
          $t("message.save")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>

export default {
  props: {
    detail: { type: Object },
  },
  data() {
    return {
      dialogVisible: false,
    };
  },
  computed: {},
  methods: {
    // 保存
    save() {
      let datas = {
        user_id: this.$route.query.userID,
        is_vip: this.detail.is_vip,
      };
      this.$api.clienteleApi.setClientAttribute(datas).then((res) => {
        this.$message.success(res.msg);
        this.dialogVisible = false;
        this.$parent.clientDetail();
      });
    },
  },
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0px 15px;
  display: flex;

  .key {
    flex: 1;
    line-height: 40px;
    text-align: center;
  }

  .val {
    flex: 3;
  }
}

/deep/.el-radio__input {
  transform: scale(1.5) !important;
}
</style>